import React, { useEffect, useRef, useState, useCallback } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import styles from './Projects.module.css';

import proj1 from '../images/מורן וינברגר פרוייקטים 1.webp';
import proj2 from '../images/מורן וינברגר פרוייקטים 2.webp';
import proj3 from '../images/מורן וינברגר פרוייקטים 3.webp';
import proj4 from '../images/מורן וינברגר פרוייקטים 4.webp';
import proj5 from '../images/מורן וינברגר פרוייקטים 5.webp';
import proj6 from '../images/מורן וינברגר פרוייקטים 6.webp';
import proj7 from '../images/מורן וינברגר פרוייקטים 7.webp';
import proj8 from '../images/מורן וינברגר פרוייקטים 8.webp';
import proj9 from '../images/מורן וינברגר פרוייקטים 9.webp';
import proj10 from '../images/מורן וינברגר פרוייקטים 10.webp';
import proj11 from '../images/מורן וינברגר פרוייקטים 11.webp';
import proj12 from '../images/מורן וינברגר פרוייקטים 12.webp';
import proj13 from '../images/מורן וינברגר פרוייקטים 13.webp';
import proj14 from '../images/מורן וינברגר פרוייקטים 14.webp';
import proj15 from '../images/מורן וינברגר פרוייקטים 15.webp';
import proj16 from '../images/מורן וינברגר פרוייקטים 16.webp';
import proj17 from '../images/מורן וינברגר פרוייקטים 17.webp';
import proj18 from '../images/מורן וינברגר פרוייקטים 18.webp';
import proj19 from '../images/מורן וינברגר פרוייקטים 19.webp';
import proj20 from '../images/מורן וינברגר פרוייקטים 20.webp';
import proj21 from '../images/מורן וינברגר פרוייקטים 21.webp';
import proj22 from '../images/מורן וינברגר פרוייקטים 22.webp';
import proj23 from '../images/מורן וינברגר פרוייקטים 23.webp';
import proj24 from '../images/מורן וינברגר פרוייקטים 24.webp';
import proj25 from '../images/מורן וינברגר פרוייקטים 25.webp';
import proj26 from '../images/מורן וינברגר פרוייקטים 26.webp';
import proj27 from '../images/מורן וינברגר פרוייקטים 27.webp';
import proj28 from '../images/מורן וינברגר פרוייקטים 28.webp';
import proj29 from '../images/מורן וינברגר פרוייקטים 29.webp';
import proj30 from '../images/מורן וינברגר פרוייקטים 30.webp';
import proj31 from '../images/מורן וינברגר פרוייקטים 31.webp';
import proj33 from '../images/מורן וינברגר פרוייקטים 33.webp';
import proj34 from '../images/מורן וינברגר פרוייקטים 34.webp';
import proj35 from '../images/מורן וינברגר פרוייקטים 35.webp';
import proj36 from '../images/מורן וינברגר פרוייקטים 36.webp';
import proj37 from '../images/מורן וינברגר פרוייקטים 37.webp';
import proj38 from '../images/מורן וינברגר פרוייקטים 38.webp';
import proj39 from '../images/מורן וינברגר פרוייקטים 39.webp';
import proj40 from '../images/מורן וינברגר פרוייקטים 40.webp';
import proj41 from '../images/מורן וינברגר פרוייקטים 41.webp';
import proj42 from '../images/מורן וינברגר פרוייקטים 42.webp';
import proj43 from '../images/מורן וינברגר פרוייקטים 43.webp';
import proj44 from '../images/מורן וינברגר פרוייקטים 44.webp';
import proj45 from '../images/מורן וינברגר פרוייקטים 45.webp';
import proj46 from '../images/מורן וינברגר פרוייקטים 46.webp';
import proj47 from '../images/מורן וינברגר פרוייקטים 47.webp';
import proj48 from '../images/מורן וינברגר פרוייקטים 48.webp';
import proj49 from '../images/מורן וינברגר פרוייקטים 49.webp';
import proj50 from '../images/מורן וינברגר פרוייקטים 50.webp';
import proj51 from '../images/מורן וינברגר פרוייקטים 51.webp';
import proj52 from '../images/מורן וינברגר פרוייקטים 52.webp';
import proj53 from '../images/מורן וינברגר פרוייקטים 53.webp';
import proj54 from '../images/מורן וינברגר פרוייקטים 54.webp';
import proj55 from '../images/מורן וינברגר פרוייקטים 55.webp';
import proj56 from '../images/מורן וינברגר פרוייקטים 56.webp';
import proj57 from '../images/מורן וינברגר פרוייקטים 57.webp';
import proj58 from '../images/מורן וינברגר פרוייקטים 58.webp';
import proj59 from '../images/מורן וינברגר פרוייקטים 59.webp';
import proj60 from '../images/מורן וינברגר פרוייקטים 60.webp';
import proj61 from '../images/מורן וינברגר פרוייקטים 61.webp';
import proj62 from '../images/מורן וינברגר פרוייקטים 62.webp';
import proj63 from '../images/מורן וינברגר פרוייקטים 63.webp';
import proj64 from '../images/מורן וינברגר פרוייקטים 64.webp';
import proj65 from '../images/מורן וינברגר פרוייקטים 65.webp';
import proj66 from '../images/מורן וינברגר פרוייקטים 66.webp';
import proj67 from '../images/מורן וינברגר פרוייקטים 67.webp';
import proj68 from '../images/מורן וינברגר פרוייקטים 68.webp';
import proj69 from '../images/מורן וינברגר פרוייקטים 69.webp';
import proj70 from '../images/מורן וינברגר פרוייקטים 70.webp';
import proj71 from '../images/מורן וינברגר פרוייקטים 71.webp';

gsap.registerPlugin(ScrollTrigger);

const featuredProjects = [
  {
    id: 1,
    title: 'מסעדת ג׳ונם',
    subtitle: 'עיצוב פנים למסעדה',
    description: 'שילוב של אווירה אינטימית עם נגיעות עכשוויות',
    fullDescription:
      'מסעדת ג׳ונם היא פרויקט שבו הצלחנו לשלב בין האווירה המסורתית של מטבח אסייתי לבין עיצוב מודרני ונקי. החלל תוכנן כך שכל פינה מספרת סיפור - מהתאורה החמימה שמקיפה את השולחנות ועד לפרטי הנגרות המותאמים אישית. עבדנו עם חומרים טבעיים כמו עץ ואבן, בשילוב אלמנטים מתכתיים שמוסיפים נגיעה תעשייתית עדינה.',
    heroImage: proj1,
    tags: ['מסעדות', 'עיצוב מסחרי'],
    gallery: [proj1, proj2, proj3],
  },
  {
    id: 2,
    title: 'ישיבת דגל ירושלים',
    subtitle: 'עיצוב מוסדי',
    description: 'מרחב לימודי מעורר השראה המשלב מסורת וחדשנות',
    fullDescription:
      'פרויקט הישיבה היה אתגר מרתק - ליצור מרחב שמכבד את המסורת העשירה תוך מתן מענה לצרכים המודרניים של לימוד ועבודה. תכננו חללי לימוד פתוחים לצד חדרי חברותא אינטימיים, ספרייה מרשימה עם גלריות אור טבעי, ואזורי מנוחה שמאפשרים רגעי שקט. השתמשנו בפלטת צבעים חמה ובחומרים איכותיים שיעמדו במבחן הזמן.',
    heroImage: proj4,
    tags: ['מוסדות', 'חינוך'],
    gallery: [proj4, proj5, proj6],
  },
];

// מסחרי קודם, אחר כך מגורים
const miscImages = [proj3, proj2, proj6, proj5, proj7, proj8];
// tall / wide = אינדקסים בתוך כל קבוצה שמקבלים משבצת גדולה בגריד
const imageGroups = [
  {
    title: 'מסחרי',
    alt: 'עיצוב מסחרי',
    // מסעדה, חנויות, משרדי Homage Design, אולם תצוגה, מעונות הישיבה ומסעדת רוטמנס / toast
    images: [
      proj35, proj9, proj50, proj45, proj37, proj18,
      proj48, proj51, proj52, proj40, proj10, proj53,
      proj47, proj42, proj54, proj6, proj22, proj55,
      proj49, proj46, proj56, proj2, proj44, proj57,
      proj11, proj21, proj58, proj38, proj34, proj59,
      proj36, proj19, proj60, proj39, proj33, proj61,
      proj20, proj41, proj62, proj23, proj43, proj63,
      proj29, proj30, proj64, proj1, proj3, proj31,
    ],
    tall: [0, 5, 30],
    wide: [3, 8, 20],
  },
  {
    title: 'מגורים',
    alt: 'עיצוב פנים למגורים',
    images: [
      proj66, proj12, proj25, proj67, proj26, proj68,
      proj13, proj28, proj4, proj65, proj27, proj14,
      proj69, proj15, proj16, proj70, proj5, proj17,
      proj71, proj7, proj8, proj24,
    ],
    tall: [0, 5, 19],
    wide: [3, 8],
  },
];

const ProjectsSection = () => {
  const sectionRef = useRef(null);
  const headerRef = useRef(null);
  const featuredRefs = useRef([]);
  const numberFillRefs = useRef([]);
  const galleryTrackRef = useRef(null);
  const galleryItemRefs = useRef([]);
  const galleryTitleRef = useRef(null);
  const dragState = useRef({ isDragging: false, startX: 0, scrollLeft: 0, moved: false });

  const [modalOpen, setModalOpen] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);
  const [galleryOpen, setGalleryOpen] = useState(false);
  const [galleryIndex, setGalleryIndex] = useState(0);
  const [galleryImages, setGalleryImages] = useState([]);

  /* ============ Image parallax + cursor glow ============ */
  const handleMouseMove = useCallback((e, index) => {
    const row = featuredRefs.current[index];
    if (!row) return;
    const wrap = row.querySelector('[data-img-wrap]');
    if (!wrap) return;
    const rect = wrap.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    const px = (x / rect.width - 0.5) * -15;
    const py = (y / rect.height - 0.5) * -10;

    const img = wrap.querySelector('[data-parallax]');
    if (img) gsap.to(img, { x: px, y: py, duration: 0.8, ease: 'power2.out' });

    const glow = wrap.querySelector('[data-glow]');
    if (glow) {
      glow.style.background = `radial-gradient(500px circle at ${x}px ${y}px, rgba(68,79,71,0.06), transparent 60%)`;
    }
  }, []);

  const handleMouseLeave = useCallback((index) => {
    const row = featuredRefs.current[index];
    if (!row) return;
    const img = row.querySelector('[data-parallax]');
    if (img) gsap.to(img, { x: 0, y: 0, duration: 0.6, ease: 'power2.out' });
    const glow = row.querySelector('[data-glow]');
    if (glow) glow.style.background = 'transparent';
  }, []);

  /* ============ Gallery drag-to-scroll ============ */
  const handleDragStart = useCallback((e) => {
    const track = galleryTrackRef.current;
    if (!track) return;
    dragState.current = {
      isDragging: true,
      startX: (e.pageX || e.touches?.[0]?.pageX) - track.offsetLeft,
      scrollLeft: track.scrollLeft,
      moved: false,
    };
    track.style.cursor = 'grabbing';
    track.style.userSelect = 'none';
  }, []);

  const handleDragMove = useCallback((e) => {
    if (!dragState.current.isDragging) return;
    const track = galleryTrackRef.current;
    if (!track) return;
    const x = (e.pageX || e.touches?.[0]?.pageX) - track.offsetLeft;
    const walk = x - dragState.current.startX;
    if (Math.abs(walk) > 5) dragState.current.moved = true;
    track.scrollLeft = dragState.current.scrollLeft - walk * 1.5;
  }, []);

  const handleDragEnd = useCallback(() => {
    dragState.current.isDragging = false;
    const track = galleryTrackRef.current;
    if (track) {
      track.style.cursor = 'grab';
      track.style.userSelect = '';
    }
  }, []);

  const handleGalleryCardClick = useCallback(
    (images, index) => {
      if (!dragState.current.moved) openGallery(images, index);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  /* ============ GSAP animations ============ */
  useEffect(() => {
    const section = sectionRef.current;
    if (!section) return;

    const ctx = gsap.context(() => {
      // Header entrance
      if (headerRef.current) {
        gsap.fromTo(
          headerRef.current.children,
          { opacity: 0, y: 50 },
          {
            opacity: 1, y: 0,
            duration: 0.7, stagger: 0.08, ease: 'power3.out',
            scrollTrigger: { trigger: section, start: 'top 70%', toggleActions: 'play none none none' },
          }
        );
      }

      // Mixed reveal effects (like hen-afriat)
      const revealEffects = [
        { from: { clipPath: 'inset(0% 0% 100% 0%)', opacity: 0 }, to: { clipPath: 'inset(0% 0% 0% 0%)', opacity: 1, duration: 1.1, ease: 'power3.inOut' } },
        { from: { clipPath: 'inset(0% 100% 0% 0%)', opacity: 0 }, to: { clipPath: 'inset(0% 0% 0% 0%)', opacity: 1, duration: 1.1, ease: 'power3.inOut' } },
        { from: { scale: 0.7, opacity: 0 }, to: { scale: 1, opacity: 1, duration: 1.0, ease: 'power3.out' } },
        { from: { y: 120, opacity: 0, rotateX: 8 }, to: { y: 0, opacity: 1, rotateX: 0, duration: 1.1, ease: 'power3.out' } },
        { from: { clipPath: 'inset(50% 50% 50% 50%)', opacity: 0 }, to: { clipPath: 'inset(0% 0% 0% 0%)', opacity: 1, duration: 1.2, ease: 'power3.inOut' } },
        { from: { x: -80, opacity: 0, scale: 0.92 }, to: { x: 0, opacity: 1, scale: 1, duration: 1.0, ease: 'power3.out' } },
      ];

      const gridItems = section.querySelectorAll('[data-grid-item]');
      gridItems.forEach((item, i) => {
        const img = item.querySelector('img');
        const innerFrame = item.querySelector('[data-inner-frame]');
        const effect = revealEffects[i % revealEffects.length];

        // Card reveal with mixed effects
        gsap.fromTo(item,
          { ...effect.from },
          {
            ...effect.to,
            delay: (i % 3) * 0.12,
            scrollTrigger: {
              trigger: item,
              start: 'top 93%',
              end: 'top 50%',
              toggleActions: 'play none none none',
            },
          }
        );

        // Deep parallax on the image
        if (img) {
          gsap.fromTo(img,
            { yPercent: -10, scale: 1.18 },
            {
              yPercent: 10,
              ease: 'none',
              scrollTrigger: {
                trigger: item,
                start: 'top bottom',
                end: 'bottom top',
                scrub: 1.8,
              },
            }
          );
        }

        // Inner frame fade in
        if (innerFrame) {
          gsap.fromTo(innerFrame,
            { opacity: 0 },
            {
              opacity: 1,
              duration: 0.7,
              delay: 0.5 + (i % 3) * 0.12,
              ease: 'power2.out',
              scrollTrigger: {
                trigger: item,
                start: 'top 93%',
                toggleActions: 'play none none none',
              },
            }
          );
        }
      });
    }, section);

    return () => ctx.revert();
  }, []);

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape') {
        if (galleryOpen) setGalleryOpen(false);
        else if (modalOpen) setModalOpen(false);
      }
    };
    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, [modalOpen, galleryOpen]);

  useEffect(() => {
    document.body.style.overflow = modalOpen || galleryOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [modalOpen, galleryOpen]);

  const openModal = (project) => { setSelectedProject(project); setModalOpen(true); };
  const openGallery = (images, index) => { setGalleryImages(images); setGalleryIndex(index); setGalleryOpen(true); };
  const nextImage = () => setGalleryIndex((p) => (p + 1) % galleryImages.length);
  const prevImage = () => setGalleryIndex((p) => (p - 1 + galleryImages.length) % galleryImages.length);

  return (
    <section ref={sectionRef} className={styles.section} id="פרוייקטים">
      <div className={styles.bgPattern} />
      <div className={styles.bgOrb1} />
      <div className={styles.bgOrb2} />

      {/* Header */}
      <div ref={headerRef} className={styles.header}>
        <h2 className={styles.title}>מקבץ פרוייקטים</h2>
      </div>

      {/* ========== Image Grid ========== */}
      <div className={styles.imageGrid}>
        <p className={styles.imageGridSubtitle}>
          קיבצתי עבורכם כמה תמונות מפרויקטים שליוויתי - עיצוב פנים למגורים, חללים מסחריים, מטבחים בהתאמה אישית ועוד
        </p>
        {imageGroups.map((group) => (
          <div key={group.title} className={styles.imageGridGroup}>
            <h3 className={styles.imageGridGroupTitle}>{group.title}</h3>
            <div className={styles.imageGridWrap}>
              {group.images.map((img, i) => (
                <div
                  key={i}
                  data-grid-item
                  className={`${styles.imageGridItem} ${group.tall.includes(i) ? styles.imageGridItemTall : ''} ${group.wide.includes(i) ? styles.imageGridItemWide : ''}`}
                  onClick={() => openGallery(group.images, i)}
                >
                  <img src={img} alt={`${group.alt} של מורן וינברגר ${i + 1}`} className={styles.imageGridImg} loading="lazy" decoding="async" />
                  <div className={styles.imageGridInnerFrame} data-inner-frame />
                  <div className={styles.imageGridOverlay} />
                  <div className={styles.imageGridView}>
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                      <circle cx="11" cy="11" r="8" />
                      <path d="M21 21l-4.35-4.35M11 8v6M8 11h6" />
                    </svg>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      {/* ========== Featured — Cinematic Rows ========== */}
      <div className={styles.featured}>
        {featuredProjects.map((project, i) => (
          <div
            key={project.id}
            ref={(el) => (featuredRefs.current[i] = el)}
            className={`${styles.row} ${i % 2 === 1 ? styles.rowReversed : ''}`}
          >
            {/* Image Collage */}
            <div
              className={styles.imageSide}
              data-img-wrap
              onMouseMove={(e) => handleMouseMove(e, i)}
              onMouseLeave={() => handleMouseLeave(i)}
              onClick={() => openModal(project)}
            >
              <div className={styles.collage}>
                {/* Main large image */}
                <div className={styles.collageMain}>
                  <img
                    className={styles.collageMainImg}
                    src={project.gallery[0]}
                    alt={project.title}
                    data-parallax
                    loading="lazy"
                    decoding="async"
                  />
                  <div className={styles.collageMainOverlay} />
                </div>

                {/* Side images */}
                <div className={styles.collageSideCol}>
                  <div className={styles.collageSideItem}>
                    <img src={project.gallery[1]} alt={`${project.title} 2`} loading="lazy" decoding="async" />
                  </div>
                  <div className={styles.collageSideItem}>
                    <img src={project.gallery[2]} alt={`${project.title} 3`} loading="lazy" decoding="async" />
                  </div>
                </div>
              </div>

              {/* Overlays on the whole collage */}
              <div className={styles.imgGlow} data-glow />

              <div className={styles.imgNumber}>
                <span className={styles.numOutline}>0{i + 1}</span>
                <span
                  ref={(el) => (numberFillRefs.current[i] = el)}
                  className={styles.numFill}
                >0{i + 1}</span>
              </div>

              <span className={`${styles.imgCorner} ${styles.imgCornerTR}`} data-corner />
              <span className={`${styles.imgCorner} ${styles.imgCornerBL}`} data-corner />

              <div className={styles.viewPrompt}>
                <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <circle cx="11" cy="11" r="8" />
                  <path d="M21 21l-4.35-4.35M11 8v6M8 11h6" />
                </svg>
              </div>
            </div>

            {/* Content */}
            <div className={styles.contentSide}>
              <div className={styles.tags} data-reveal>
                {project.tags.map((tag, j) => (
                  <span key={j} className={styles.tag}>{tag}</span>
                ))}
              </div>

              <h3 className={styles.projTitle} data-reveal>{project.title}</h3>
              <p className={styles.projSubtitle} data-reveal>{project.subtitle}</p>
              <p className={styles.projDesc} data-reveal>{project.description}</p>

              <button className={styles.projCta} data-reveal onClick={() => openModal(project)}>
                <span className={styles.projCtaLabel}>לצפייה בפרויקט</span>
                <span className={styles.projCtaArrow}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M5 12h14M12 5l7 7-7 7" />
                  </svg>
                </span>
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* ========== Horizontal Gallery ========== */}
      <div className={styles.gallerySection}>
        <h3 ref={galleryTitleRef} className={styles.galleryHeading}>עוד מהעבודות שלי</h3>
        <div
          ref={galleryTrackRef}
          className={styles.galleryTrack}
          onMouseDown={handleDragStart}
          onMouseMove={handleDragMove}
          onMouseUp={handleDragEnd}
          onMouseLeave={handleDragEnd}
          onTouchStart={handleDragStart}
          onTouchMove={handleDragMove}
          onTouchEnd={handleDragEnd}
        >
          {miscImages.map((img, i) => (
            <div
              key={i}
              ref={(el) => (galleryItemRefs.current[i] = el)}
              className={styles.galleryCard}
              onClick={() => handleGalleryCardClick(miscImages, i)}
            >
              <img className={styles.galleryCardImg} src={img} alt={`עוד מעבודות העיצוב של מורן וינברגר ${i + 1}`} loading="lazy" decoding="async" />
              <div className={styles.galleryCardHover}>
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <circle cx="11" cy="11" r="8" />
                  <path d="M21 21l-4.35-4.35M11 8v6M8 11h6" />
                </svg>
              </div>
            </div>
          ))}
        </div>
        <p className={styles.dragHint}>גלגלו לצדדים לעוד עבודות</p>
      </div>

      {/* CTA */}
      <div className={styles.sectionCta}>
        <a href="#contact" className={styles.ctaButton}>
          <span>בואו נדבר על הפרויקט שלכם</span>
        </a>
      </div>

      {/* ========== Project Modal (stays dark) ========== */}
      {modalOpen && selectedProject && (
        <div className={styles.modalBackdrop} onClick={() => setModalOpen(false)}>
          <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
            <button className={styles.modalClose} onClick={() => setModalOpen(false)}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M18 6L6 18M6 6l12 12" />
              </svg>
            </button>
            <div className={styles.modalHero}>
              <img src={selectedProject.heroImage} alt={selectedProject.title} loading="lazy" decoding="async" />
              <div className={styles.modalHeroOverlay} />
              <div className={styles.modalHeroContent}>
                <h2 className={styles.modalTitle}>{selectedProject.title}</h2>
                {selectedProject.subtitle && <p className={styles.modalSubtitle}>{selectedProject.subtitle}</p>}
              </div>
            </div>
            <div className={styles.modalBody}>
              <p className={styles.modalDescription}>{selectedProject.fullDescription}</p>
              {selectedProject.gallery?.length > 0 && (
                <div className={styles.modalGallery}>
                  <h4 className={styles.modalGalleryTitle}>תמונות מהפרויקט</h4>
                  <div className={styles.modalThumbnails}>
                    {selectedProject.gallery.map((img, i) => (
                      <div key={i} className={styles.modalThumb} onClick={() => openGallery(selectedProject.gallery, i)}>
                        <img src={img} alt={`${selectedProject.title} ${i + 1}`} loading="lazy" decoding="async" />
                        <div className={styles.modalThumbOverlay}>
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <circle cx="11" cy="11" r="8" />
                            <path d="M21 21l-4.35-4.35M11 8v6M8 11h6" />
                          </svg>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* ========== Fullscreen Gallery ========== */}
      {galleryOpen && galleryImages.length > 0 && (
        <div className={styles.galleryBackdrop} onClick={() => setGalleryOpen(false)}>
          <button className={styles.galleryCloseBtn} onClick={() => setGalleryOpen(false)}>
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M18 6L6 18M6 6l12 12" />
            </svg>
          </button>
          <button className={styles.galleryNavPrev} onClick={(e) => { e.stopPropagation(); prevImage(); }}>
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M15 18l-6-6 6-6" />
            </svg>
          </button>
          <button className={styles.galleryNavNext} onClick={(e) => { e.stopPropagation(); nextImage(); }}>
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M9 18l6-6-6-6" />
            </svg>
          </button>
          <div className={styles.galleryImageWrap} onClick={(e) => e.stopPropagation()}>
            <img src={galleryImages[galleryIndex]} alt={`עיצוב פנים בעבודתה של מורן וינברגר ${galleryIndex + 1}`} className={styles.galleryFullImage} loading="lazy" decoding="async" />
          </div>
          <div className={styles.galleryCounter}>{galleryIndex + 1} / {galleryImages.length}</div>
        </div>
      )}
    </section>
  );
};

export default ProjectsSection;